import { render, staticRenderFns } from "./BurgerIcon.vue?vue&type=template&id=6f05f9a6&scoped=true&"
import script from "./BurgerIcon.vue?vue&type=script&lang=ts&"
export * from "./BurgerIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BurgerIcon.vue?vue&type=style&index=0&id=6f05f9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05f9a6",
  null
  
)

export default component.exports